/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";

import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import AuthFormAutosuggest from "./AuthFormAutosuggest";
import classNames from "classnames";

import { FormGroup } from "../../common-components";
import { getUniversities } from "../data/service";
import messages from "../messages";

const UniversityRo = (props) => {
  const { formatMessage } = useIntl();

  const {
    onChangeHandler,
    selectedTown,
    selectedRegion,
    selectedUniversity,
    roSelected,
    isTeacher,
    errorMessage,
    onFocusHandler,
  } = props;

  const [universities, setUniversities] = useState([]);
  useEffect(() => {
    const fetchUniversities = async () => {
      if (roSelected) {
        const universityro = await getUniversities(
          selectedRegion.selectionValue,
          selectedTown.selectionValue,
          isTeacher
        );
        setUniversities(universityro);
      }
      onChangeHandler({ target: { name: "universityro", value: "" } });
    };
    fetchUniversities();
  }, [selectedRegion, selectedTown, roSelected]);

  useEffect(() => {
        if (props.errorMessage === undefined){
          return
        }
        if (props.errorMessage !== "") {
          handleOnChange("");
        }
        
      }, [errorMessage]);
  

  const handleOnChange = (value) => {
    onChangeHandler({ target: { name: "universityro", value: value } });
  };

  return (
    <div className="mb-4">
      {roSelected ? (
        <AuthFormAutosuggest
        floatingLabel={
          `${isTeacher
            ? formatMessage(messages["education.university.last"])
            : formatMessage(messages["education.university.select"])
          } *`
        }
          aria-label="form autosuggest"
          name="universityro"
          value={selectedUniversity}
          className={classNames({ "form-field-error": props.errorMessage })}
          onChange={(value) => handleOnChange(value)}
          onFocus={(e) => onFocusHandler(e)}
        >
          {roSelected
            ? universities.map((school) => (
              <FormAutosuggestOption key={school.id} id={school.id}>
                {school.name}
              </FormAutosuggestOption>
            ))
            : null}
        </AuthFormAutosuggest>
      ) : (
        <FormGroup
          name="universityro"
          value={selectedUniversity}
          handleChange={onChangeHandler}
          handleFocus={(e) => onFocusHandler(e)}
          helpText={isTeacher ? [formatMessage(messages["education.university.last.intl"])] : [formatMessage(messages["education.university.intl"])]}
          floatingLabel={isTeacher ? formatMessage(messages["education.university.last.intl"]) : formatMessage(messages["education.university.intl"])}
        />
      )}
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text-size"
          hasIcon={false}
          feedback-for="universityro"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default UniversityRo;
